import registerActionTypes from '../constants/action-types';

const registerState = {
  registerErrors: null,
  countries: [],
  userExist: {},
  showRegisterTypeModal: false,
};

export const registerReducer = (state = registerState, payload) => {
  switch (payload.type) {
    case registerActionTypes.HANDLE_REGISTER_ERROR:
      return { ...state, registerErrors: payload.data };
    case registerActionTypes.HANDLE_GET_COUNTRIES:
      return { ...state, countries: payload.data };
    case registerActionTypes.HANDLE_CHECK_USER_EXIST:
      return { ...state, userExist: payload.data };
    case registerActionTypes.TOGGLE_REGISTER_TYPE_MODAL:
      return { ...state, showRegisterTypeModal: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/register/reducers/register-reducer.js